import { baseUrl } from '../../../../config/baseUrl';
export const memberInfos = [
  {
    name: 'PGS. TS. Trần Minh Quang (PI)',
    image: `${baseUrl}img/members/TranMinhQuang.png`,
    work: 'Department of Information System, CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/bo-mon-he-thong-thong-tin',
    email: 'quangtran@hcmut.edu.vn',
    phone: '0969852729',
    webLink: 'https://researchmap.jp/quang?lang=en',
  },
  {
    name: 'TS. Nguyễn Xuân Long',
    image: `${baseUrl}img/members/NguyenXuanLong.jpg`,
    work: 'Department of Bridge and Highway Engineering, FSE, HCMUT-VNU HCM',
    workLink: 'http://www.fce.hcmut.edu.vn/',
    email: 'nxlong@hcmut.edu.vn',
    phone: '',
    webLink: 'https://sites.google.com/site/nguyenxuanlong78/',
  },
  {
    name: 'Ths. Phạm Nguyễn Hoàng Nam',
    image: `${baseUrl}img/members/PhamNguyenHoangNam.jpg`,
    work: 'Department of Information System, CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/bo-mon-he-thong-thong-tin',
    email: 'phamnguyenhoangnam@gmail.com',
    phone: '',
    webLink: '',
  },
  {
    name: 'Ths. Mai Tấn Hà',
    image: `${baseUrl}img/members/MaiTanHa.jpg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'maitanhaksdtvt6@gmail.com',
    phone: '',
    webLink: 'https://www.linkedin.com/in/mai-tan-ha-795293129/',
  },
  {
    name: 'Phạm Đỗ Đức Giang',
    image: `${baseUrl}img/members/PhamDoDucGiang.jpg`,
    work: 'Đài Tiếng nói nhân dân TP. HCM',
    workLink: 'https://voh.com.vn/',
    email: 'pddgiang.voh@tphcm.gov.vn',
    phone: '',
    webLink: 'https://www.linkedin.com/in/pham-giang-990a1a1a/',
  },
  {
    name: 'Đặng Minh Hoàng',
    image: `${baseUrl}img/members/DangMinhHoang.jpg`,
    work: 'Đài Tiếng nói nhân dân TP. HCM',
    workLink: 'https://voh.com.vn/',
    email: 'dmhoang.voh@tphcm.gov.vn',
    phone: '',
    webLink: '',
  },
  {
    name: 'Nguyễn Tấn Trung',
    image:`${baseUrl}img/members/NguyenTanTrung.jpg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'nguyentantrungs@gmail.com',
    phone: '',
    webLink: 'https://www.linkedin.com/in/nguyentantrungs/',
  },
  {
    name: 'Dương Hoài Phong',
    image: `${baseUrl}img/members/DuongHoaiPhong.jpg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: '1512432@hcmut.edu.vn',
    phone: '',
    webLink: '',
  },
  {
    name: 'Uông Sỹ Phương',
    image: `${baseUrl}img/members/UongSyPhuong.png`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'uongsyphuong@gmail.com',
    phone: '',
    webLink: '',
  },
  {
    name: 'Đào Quốc Hoàng',
    image: `${baseUrl}img/members/DaoQuocHoang.jpg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: '1511112@hcmut.edu.vn',
    phone: '',
    webLink: '',
  },
  {
    name: 'Phạm Tấn Đại',
    image: `${baseUrl}img/members/PhamTanDai.jpeg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'dai.pham.78@hcmut.edu.vn',
    phone: '0376504234',
    webLink: 'https://www.linkedin.com/in/daipham2506/',
  },
  {
    name: 'Nguyễn Nhật Minh',
    image: `${baseUrl}img/members/NhatMinh.jpg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'minh.nguyennhat@hcmut.edu.vn',
    phone: '0338616558',
    webLink: 'https://www.linkedin.com/in/nhatminhlt/',
  },
  {
    name: 'Nguyễn Lê Hoàng Hiệu',
    image: `${baseUrl}img/members/NguyenLeHoangHieu.jpeg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'hieu.nguyenlehoang@hcmut.edu.vn',
    phone: '0967740752',
    webLink: 'https://www.linkedin.com/in/hieunguyen1704/',
  },
  {
    name: 'Lê Trung Hiếu',
    image: `${baseUrl}img/members/LeTrungHieu.jpg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'hieu.letrunghieu@hcmut.edu.vn',
    phone: '0703799116',
    webLink: 'https://www.linkedin.com/in/hieult-0796b9208/',
  },
  {
    name: 'Nguyễn Gia Huy',
    image: `${baseUrl}img/members/NguyenGiaHuy.jpg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'huy.nguyen.1209@hcmut.edu.vn',
    phone: '0905849744',
    webLink: 'https://www.linkedin.com/in/ngh1290/',
  },
  {
    name: 'Nguyễn Tiến Thành',
    image: `${baseUrl}img/members/NguyenTienThanh.jpg`,
    work: 'CSE, HCMUT-VNU HCM',
    workLink: 'https://cse.hcmut.edu.vn/',
    email: 'thanh.nguyen2612@hcmut.edu.vn',
    phone: '0357157953',
    webLink: 'https://www.linkedin.com/in/thanhnguyen2612/',
  },
];
